import Vue from 'vue'
import Router from 'vue-router'
import WellManagement from '@/views/WellManagement.vue'
import PatrolManagement from '@/views/PatrolManagement.vue'
import TaskManagement from '@/views/TaskManagement.vue'
import DonationManagement from '@/views/DonationManagement.vue'
import ClaimManagement from '@/views/ClaimManagement.vue'
import TestProgressManagement from '@/views/TestProgressManagement.vue'
import RepairProgressManagement from '@/views/RepairProgressManagement.vue'
import WellClueManagement from '@/views/WellClueManagement.vue'
import UserManagement from '@/views/UserManagement.vue'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/wells' },
    { path: '/wells', component: WellManagement, meta: { title: '泉井管理' } },
    { path: '/patrols', component: PatrolManagement, meta: { title: '泉井巡护' } },
    { path: '/tasks', component: TaskManagement, meta: { title: '检测修缮' } },
    { path: '/donations', component: DonationManagement, meta: { title: '爱心捐赠管理' } },
    { path: '/claims', component: ClaimManagement, meta: { title: '守望者认领审批' } },
    { path: '/test-progress', component: TestProgressManagement, meta: { title: '检测进展' } },
    { path: '/repair-progress', component: RepairProgressManagement, meta: { title: '修缮进展' } },
    { path: '/clues', component: WellClueManagement, meta: { title: '泉井线索' } },
    { path: '/users', component: UserManagement, meta: { title: '用户管理' } }
  ]
})
